import { createReduxAsyncThunk } from 'shared/utils';

import dataSources from 'dataSources';

import { STATIONS_STATE } from '../../constants';

import { StationsState } from '../../types';

export const getRouteStationsPrices = createReduxAsyncThunk<
  StationsState['routeStationsPrices']['data'],
  string[]
>(
  `${STATIONS_STATE}/getRouteStationsPrices`,
  async (stationCodes) => {
    return await dataSources.stations.getStationsPrices(stationCodes);
  }
);
